type Props = {
  className?: string;
};

const IconSocial = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3C7.3425 3 6 4.3425 6 6C6 7.6575 7.3425 9 9 9C10.6575 9 12 7.6575 12 6C12 4.3425 10.6575 3 9 3ZM10.575 6C10.575 5.13 9.87 4.425 9 4.425C8.13 4.425 7.425 5.13 7.425 6C7.425 6.87 8.13 7.575 9 7.575C9.87 7.575 10.575 6.87 10.575 6ZM13.575 12.75C13.575 12.27 11.2275 11.175 9 11.175C6.7725 11.175 4.425 12.27 4.425 12.75V13.575H13.575V12.75ZM3 12.75C3 10.755 6.9975 9.75 9 9.75C11.0025 9.75 15 10.755 15 12.75V14.25C15 14.6625 14.6625 15 14.25 15H3.75C3.3375 15 3 14.6625 3 14.25V12.75Z"
      fill="#BEBEBE"
    />
  </svg>
);

export default IconSocial;
